

module.exports = {
  fieldSeperator: "|",
  componentSeperator: "^",
  subcomponentSeperator: "&",
  escapeCharacter: "\\",
  repititionCharacter: "~",
  segmentSeperator: '\r'
}